import { Theme } from "../types/profile";

export const applyTheme = (themeData: Theme) => {
  document.documentElement.style.setProperty("--backgroundcolor", themeData.background_color);
  document.documentElement.style.setProperty("--font-color", themeData.font_color);
  document.documentElement.style.setProperty("--font-family", themeData.font_family);
};
